import React, {useState, useEffect} from "react";
import OwlCarousel from 'react-owl-carousel2';
import PortableText from "./portableText";
import sanityClient from "@sanity/client";
import clientConfig from "../../client-config";
import * as styles from './tipsAndAdviceWidget.module.css';
import { buildImageObj, cn, getBlogUrl } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";

let owlClass = "listing-owl " + styles.listingWrap;

const options = {
    items: 3,
    nav: false,
    dots: false,
    rewind: false,
    autoplay: false,
    margin: 17,
    responsive : {
        0 : {
            items: 1,
            stagePadding: 30
        },
        900 : {
            items: 3,
            stagePadding: 0
        }
    }
};

function CategoryPreview(category) {

    let c = category.category;
    let widgetClass = styles.sectionTipsAndAdviceWidget + ' ' + styles.categoryPreview
    let preview_posts = [];

    if(c.posts.length > 0){
        
        // for(let i = 0; i < 3; i++){
        //     if(c.posts[i]){
        //         preview_posts[i] = c.posts[i];
        //     }
        // }

        preview_posts = c.posts;

        let cta_class = styles.sectionMobileCTA +' '+ styles.sectionMobileCTA__blogs

        return (
            <div className={widgetClass}>
                <div className={styles.sectionContent}>
                    <div class="container mx-auto relative">
                        <h3>{c.title}</h3>

                        <div className={owlClass}>
                    
                            <OwlCarousel options={options}>

                                {
                                    preview_posts.map((item, i) => {  

                                        let post_url = getBlogUrl(item.slug.current);
                                        let post_image = '';

                                        if(item.mainImage){
                                            post_image = (item.mainImage.asset) ? imageUrlFor(buildImageObj(item.mainImage)) : '';
                                        }

                                        return (
                                            <div className={styles.listingItem}>
                                                <a href={post_url} className={styles.itemImage}>
                                                    <div className={styles.itemImageBackground} style={{ backgroundImage: `url(${post_image})` }}></div>
                                                </a>
                                                <div className={styles.itemDetails}>
                                                    <h4><a href={post_url}>{item.title}</a></h4>
                                                    <PortableText blocks={item.excerpt} />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                    
                            </OwlCarousel>

                        </div>
                        
                        
                        <div className={cta_class}>
                            <a href="#">
                                <span>View more articles</span>
                                <img src={require('../images/arrow-right.png').default} alt="Right arrow" />
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className={widgetClass}>
                <div className={styles.sectionContent}>
                    <div class="container mx-auto relative">
                        <h3>{c.title}</h3>
                        <h5>No posts found.</h5>
                    </div>
                </div>
            </div>
        );
    }
}
  
export default CategoryPreview;